import React, { useEffect, useMemo, useState } from 'react';
import icSupportChat from 'Assets/img/ic_support_chat_32_white@2x.png';
import { useSelector } from 'react-redux';
import BasicButton from 'Components/Button/BasicButton';
import IntlMessages from 'Util/IntlMessages';

const CustomerSupportChatButton = ({ onMouseUp, onMouseDown, onClick, bottom, right }) => {
  const { newMenu } = useSelector(state => state.noty);
  const [newAlarm, setNewAlarm] = useState(false);
  const [dailyAlarm, setDailyAlarm] = useState(false);

  const lastDailyAlarm = useMemo(() => {
    try {
      const value = localStorage.getItem('lastDailyAlarm');
      return value ? new Date(value) : null;
    } catch (e) {
      return null;
    }
  }, []);

  const closeDailyAlarm = () => {
    localStorage.setItem('lastDailyAlarm', new Date().toISOString());
    setDailyAlarm(false);
  };

  useEffect(() => {
    if (lastDailyAlarm) {
      const now = new Date();
      const lastDate = new Date(lastDailyAlarm);
      const isSameDay = now.getFullYear() === lastDate.getFullYear() && now.getMonth() === lastDate.getMonth() && now.getDate() === lastDate.getDate();
      if (!isSameDay) {
        setDailyAlarm(true);
      }
    } else {
      setDailyAlarm(true);
    }
  }, [lastDailyAlarm]);

  useEffect(() => {
    if (newMenu?.global?.CUSTOMER_SUPPORT_CHAT > 0) {
      setNewAlarm(true);
    } else {
      setNewAlarm(false);
    }
  }, [newMenu]);

  return (
    <div
      className='customer-support-chat-button'
      style={{ bottom, right }}
      onMouseUp={onMouseUp}
      onMouseDown={onMouseDown}
      onClick={e => {
        onClick(e);
        closeDailyAlarm();
      }}
    >
      {newAlarm ? (
        <div className='customer-support-chat-button-alarm cursor-pointer'>
          <div className='customer-support-chat-button-alarm-text'>
            <IntlMessages id='customer.support.chat.button.alarm.text' />
          </div>
          <BasicButton
            type='subtle'
            textId='button.close'
            size='x-small'
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              setNewAlarm(false);
              closeDailyAlarm();
            }}
          />
        </div>
      ) : (
        dailyAlarm && (
          <div className='customer-support-chat-button-alarm cursor-pointer'>
            <div className='customer-support-chat-button-daily-alarm-wrapper'>
              <div className='customer-support-chat-button-daily-alarm-wrapper-text1'>
                <IntlMessages id='customer.support.chat.daily.alarm.text.1' />
              </div>
              <div className='customer-support-chat-button-daily-alarm-wrapper-text2'>
                <IntlMessages id='customer.support.chat.daily.alarm.text.2' />
              </div>
            </div>
            <BasicButton
              type='subtle'
              textId='button.close'
              size='x-small'
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                closeDailyAlarm();
              }}
            />
          </div>
        )
      )}
      <div className='customer-support-chat-button-icon cursor-pointer'>
        <img src={icSupportChat} alt='support chat' style={{ width: '32px', height: '32px' }} draggable={false} onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
      </div>
    </div>
  );
};

export default CustomerSupportChatButton;
